// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import reportFilingEntity from './entities/report-filing.json';
import reportFilingMenu from '../pages/report-filing/menu.json';
import reportFilingFullForm from '../pages/report-filing/forms/full.json';
import reportFilingContextForm from '../pages/report-filing/forms/context.json';
import reportFilingMiniForm from '../pages/report-filing/forms/mini.json';
import reportFilingLookupForm from '../pages/report-filing/forms/lookup.json';
import reportFilingTableView from '../pages/report-filing/views/table.json';
import reportFilingCardsView from '../pages/report-filing/views/cards.json';
import reportFilingDashboardView from '../pages/report-filing/views/dashboard.json';

/** Тип запису «Подання звіту» зі сторінками пакета: меню, форми та подання з pages/report-filing/. */
export const reportFilingDefinition: IRecordTypeDefinition = {
  ...reportFilingEntity,
  views: assembleViewSet({
      table: reportFilingTableView,
      cards: reportFilingCardsView,
      dashboard: reportFilingDashboardView,
  }),
  form: reportFilingFullForm,
  forms: { full: reportFilingFullForm, context: reportFilingContextForm, mini: reportFilingMiniForm, lookup: reportFilingLookupForm },
  menu: reportFilingMenu,
} as IRecordTypeDefinition;
